import { useEffect, useState } from 'react';

/**
 * Returns the current on-screen keyboard height in px (0 when keyboard is hidden).
 * Uses the visualViewport API — supported on iOS 13+ and Chrome 61+.
 * Primary use: shift fixed bottom sheets above the keyboard via `style={{ bottom: keyboardHeight }}`.
 */
export function useKeyboardHeight() {
  const [height, setHeight] = useState(0);
  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;
    const update = () =>
      setHeight(Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop)));
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, []);
  return height;
}
